export const rcpValues = ["rcp26", "rcp45", "rcp60", "rcp85"] as const;

export type Rcp = (typeof rcpValues)[number];
